export enum ChatSummaryEventType {
    IncrementalUpdate,
    ScrollingUpdate,
}

export interface ChatSummaryEvent {
    eventType: ChatSummaryEventType;
    data: Object;
}
